export default __webpack_public_path__ + "static/media/unplanned-downtime.24df4933.svg";